import React, { FC } from 'react'
import { Loading } from '@ads/front-core/atoms'
import { getWidthHeight } from '@ads/front-core/utils'
import { PreviewMethod } from '../interfaces'
import { ICreationPreviewMethod } from './interfaces'
import { BaseIframe } from './BaseIframe'
import { onLoad } from './utils'
import { useFetchPreviewHTML } from './useFetchPreviewHTML'

export const FetchHtml: FC<
  ICreationPreviewMethod<PreviewMethod.FETCH_HTML>
> = ({ creation, creationRef }) => {
  const creationDimensions = getWidthHeight(creation.size)

  const { previewHTML, isLoading } = useFetchPreviewHTML(creation.requestBody)

  if (isLoading) {
    return <Loading />
  }

  return (
    <BaseIframe
      ref={creationRef}
      onLoad={
        !creationDimensions?.width && !creation.isFullWindowSize
          ? () => onLoad(creationRef?.current)
          : null
      }
      sandbox="allow-same-origin allow-scripts allow-popups"
      srcDoc={previewHTML}
      iframeWidth={creationDimensions?.width}
      iframeHeight={creationDimensions?.height}
    />
  )
}
